import ResetForm from './ResetForm'
import enhance from './ResetForm.enhancer'

export default enhance(ResetForm)



// WEBPACK FOOTER //
// ./src/components/organisms/ResetForm/index.js